import { CustomerRoleT } from '@/api/apis/customer';

export enum OrganizationType {
  TxCenter = 'TxCenter',
  OPO = 'OPO',
}

export type Organization = {
  id: string;
  name: string;
  code: string;
  countryCode?: string;
  roles: CustomerRoleT[];
  permissions: string[];
  isPrimary: boolean;
  type: OrganizationType;
  trialPrograms?: string[];
};
